import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-checkout-redirect',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checkout-redirect.html',
  styleUrl: './checkout-redirect.scss',
})
export class MobileCheckoutRedirect implements OnInit {
  ngOnInit() {
    window.location.href = 'residents://booking-payment-result';
  }
}
